import React from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import moment from 'moment';
import { Button, Calendar, Popover, PopoverContent, PopoverTrigger, } from '@cargomatic/ui';
/**
 * Date range picker filter using @cargomatic/ui Calendar.
 */
export function FilterDateRange({ value, onChange, placeholder = 'Date Range', numberOfMonths = 2, }) {
    const formatLabel = () => {
        if (value === null || value === void 0 ? void 0 : value.from) {
            const from = moment(value.from).format('MMM D, YYYY');
            if (value.to) {
                const to = moment(value.to).format('MMM D, YYYY');
                return `${from} - ${to}`;
            }
            return from;
        }
        return placeholder;
    };
    return (React.createElement(Popover, null,
        React.createElement(PopoverTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", size: "sm", className: "w-full justify-start font-normal h-8 border-dashed" },
                React.createElement(CalendarIcon, { className: "size-3 mr-1.5 text-muted-foreground" }),
                React.createElement("span", { className: "text-muted-foreground text-xs" }, formatLabel()))),
        React.createElement(PopoverContent, { className: "w-auto p-0", align: "start" },
            React.createElement(Calendar, { mode: "range", numberOfMonths: numberOfMonths, selected: value, onSelect: onChange }))));
}
